import { createUsePermissions } from "./createUsePermissions";

export const usePagesPermissions = createUsePermissions("pb.page");
